import { CommonPrintProps } from 'approot/activity-builder/activity-builder.constants';
import ColumnsComponentsPrint from './columns-components-print';
import { ViewProps } from './columns.constants';
import * as Styled from './columns-print.style';
import {
  getAppliedColour,
  isBackgroundApplied,
  isBorderApplied,
} from './settings/column-settings.utils';
import { LanguageCodes } from 'global/constants';

const ColumnsPrint = ({
  columns,
  columnProperties,
  isPrintPreview,
  language,
  onRenderComplete,
  contentVersion,
}: ViewProps &
  CommonPrintProps & {
    language: LanguageCodes;
    onRenderComplete?: () => void;
    contentVersion: string | null | undefined;
  }) => (
  <Styled.ColumnsPrintContainer
    $turnOffResponsive
    $colours={getAppliedColour(columnProperties?.style)}
    $showBackground={isBackgroundApplied(columnProperties?.style)}
    $showBorder={isBorderApplied(columnProperties?.style)}
  >
    {columns?.map(column => (
      <Styled.ColumnsPrintColumn
        key={column.columnId}
        $colspan={column.colspan}
        $alignment={column.alignment}
        $colours={getAppliedColour(column.style)}
        $showBorder={isBorderApplied(column.style)}
        $showBackground={isBackgroundApplied(column.style)}
      >
        <ColumnsComponentsPrint
          column={column}
          language={language}
          isPrintPreview={isPrintPreview}
          onRenderComplete={onRenderComplete}
          contentVersion={contentVersion}
        />
      </Styled.ColumnsPrintColumn>
    ))}
  </Styled.ColumnsPrintContainer>
);

export default ColumnsPrint;
